let $ = jQuery.noConflict(),
	devMode,
	mobileCheck = false,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	clickOrTouch,
	mobileResizeCallbacks = [];

$(function () {
	// new RichText();
	new StarterKitMcube();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		// Composants Desktop uniquement
		new SmoothScroll();
	}

	if (window.innerWidth > 767) {
		new BlockStoriesBlockMembers();
		new ProductGallery();
		new BlockBigTextScrollingImage();
	}

	// Composants Mobile & Desktop
	new ArchiveProduct();
	new BlockKeyFigures();
	new BlockStoriesDark();
	new BlockProductsSlider();
	new BlockTimeline();
	new Collapses();
	new ContactPage();
	window.customPrescription = new CustomPrescription();
	new Documentation();
	new Footer();
	new Inputs();
	new JLFSearch();
	new Header();
	new HeaderMobile();
	new RelatedProducts();
	new Share();
	new SingleNews();
	new SingleProduct();
	new StoreLocator();
	new TextUnderline();
	new Wishlist();
});
